import { render, staticRenderFns } from "./tord_before_check.vue?vue&type=template&id=6dcb2c00&scoped=true&"
import script from "./tord_before_check.vue?vue&type=script&lang=js&"
export * from "./tord_before_check.vue?vue&type=script&lang=js&"
import style0 from "./tord_before_check.vue?vue&type=style&index=0&id=6dcb2c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb2c00",
  null
  
)

export default component.exports